import React from "react";
import ProjectsListPagination from "./ProjectsListPagination";
import ProjectListItem from "./ProjectListItem";

const ProjectsList = ({
  projects,
  selectedRows,
  handleRowSelection,
  isOpenPagination,
  openPagination,
  paginationRef,
  totalCount,
  totalPages,
  currentPage,
  limit,
  handleProjectsPage,
}) => {
  return (
    <div className="relative rounded-xl border border-neutral-20 bg-neutral-0 shadow-black-5 transition-all duration-200 dark:shadow-black-40 dark:border-neutral-100 dark:bg-neutral-100 w-full">
      <div className="flex flex-col gap-4">
        <div className="relative w-full">
          <div className="max-w-full overflow-y-hidden overflow-x-scroll scroll-smooth scrollbar-hide">
            <div
              className="relative grid w-full min-w-fit items-center"
              style={{
                gridTemplateColumns:
                  "minmax(max-content, 0.3fr) minmax(max-content, 0.3fr) minmax(max-content, 1fr) minmax(max-content, 0.75fr) minmax(max-content, 0.75fr) minmax(max-content, 0.5fr) minmax(max-content, 0.5fr) minmax(max-content, 0.5fr) minmax(max-content, 0.5fr) minmax(max-content, 0.5fr) minmax(max-content, 0.75fr)",
              }}
            >
              <div className="group contents">
                <div className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start sticky z-10 left-0 py-3 text-xs rounded-b-l-0">
                  <div className="min-w-0 flex-shrink overflow-hidden"></div>
                </div>
                <div className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start sticky z-10 left-0 py-3 text-xs">
                  <div className="min-w-0 flex-shrink overflow-hidden">#</div>
                </div>
                <div className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start sticky z-10 left-0 py-3 text-xs">
                  <div className="min-w-0 flex-shrink overflow-hidden">
                    Project Name
                  </div>
                </div>
                <div className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start py-3 text-xs">
                  <div className="min-w-0 flex-shrink overflow-hidden">
                    Price (24h)
                  </div>
                </div>
                <div className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start py-3 text-xs">
                  <div className="min-w-0 flex-shrink overflow-hidden">
                    MarketCap
                  </div>
                </div>
                <div className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start py-3 text-xs">
                  <div className="min-w-0 flex-shrink overflow-hidden">
                    Chain
                  </div>
                </div>
                <div
                  role="button"
                  tabindex="0"
                  className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start cursor-pointer py-3 text-xs"
                >
                  <div className="min-w-0 flex-shrink overflow-hidden">
                    <div>Score</div>
                  </div>
                </div>
                <div className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start py-3 text-xs">
                  <div className="min-w-0 flex-shrink overflow-hidden">
                    <div>Audits</div>
                  </div>
                </div>
                <div className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start py-3 text-xs">
                  <div className="min-w-0 flex-shrink overflow-hidden">
                    Has KYC
                  </div>
                </div>
                <div className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start py-3 text-xs">
                  <div className="min-w-0 flex-shrink overflow-hidden">
                    Txn (24h)
                  </div>
                </div>
                <div
                  role="button"
                  tabindex="0"
                  className="flex h-full items-center gap-1 bg-neutral-5 px-2 font-semibold text-neutral-60 transition-colors first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 dark:bg-neutral-95 dark:text-neutral-40 justify-start cursor-pointer py-3 text-xs rounded-b-r-0"
                >
                  <div className="min-w-0 flex-shrink overflow-hidden">
                    Audit Release
                  </div>
                </div>
              </div>
              {projects?.map((p, index) => (
                <ProjectListItem
                  p={p}
                  index={index}
                  currentPage={currentPage}
                  limit={limit}
                />
              ))}
            </div>
          </div>
        </div>
        <ProjectsListPagination
          selectedRows={selectedRows}
          handleRowSelection={handleRowSelection}
          isOpenPagination={isOpenPagination}
          openPagination={openPagination}
          paginationRef={paginationRef}
          totalCount={totalCount}
          totalPages={totalPages}
          currentPage={currentPage}
          limit={limit}
          handleProjectsPage={handleProjectsPage}
        />
      </div>
    </div>
  );
};

export default ProjectsList;
